import { useState } from "react";
import httpService from "../../services/httpService";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import ClubDetailsModal from "./ClubDetailsModal";

const ListenerJoinWithCode = () => {
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedClubGuid, setSelectedClubGuid] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleLookup = async (e) => {
        e.preventDefault();
        const codeToSend = code.trim();
        if (!codeToSend) return;

        setLoading(true);
        setError(null);

        try {
            const res = await httpService.post("invite/lookup", { code: codeToSend });
            setSelectedClubGuid(res.data.data.podcast_club.guid);
            setShowModal(true);
        } catch (err) {
            setError(err.response?.data?.message || "Something went wrong. Please check the code and try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleModalClose = () => {
        setShowModal(false);
        setSelectedClubGuid(null);
        setCode("");
    };

    return (
        <>
            <div style={{ maxWidth: 480 }} className="mt-2">
                <p className="text-muted small mb-3">
                    Enter the invite code you received to preview and join a club.
                </p>

                {error && <Alert variant="danger" onClose={() => setError(null)} dismissible>{error}</Alert>}

                <Form onSubmit={handleLookup}>
                    <Form.Group className="mb-3" controlId="joinCode">
                        <Form.Label>Invite code</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="e.g. LEADER2026"
                            value={code}
                            onChange={(e) => setCode(e.target.value.toUpperCase())}
                            disabled={loading}
                            autoFocus
                        />
                    </Form.Group>
                    <Button type="submit" variant="primary" disabled={!code.trim() || loading}>
                        {loading
                            ? <><Spinner animation="border" size="sm" className="me-2" />Checking…</>
                            : "Find club"
                        }
                    </Button>
                </Form>
            </div>

            <ClubDetailsModal
                show={showModal}
                onHide={handleModalClose}
                clubGuid={selectedClubGuid}
                inviteCode={code}
            />
        </>
    );
};

export default ListenerJoinWithCode;
